import { isPro } from '@/utils/index.js';
const host = isPro() ? 'https://huitucollect.map.qq.com' : 'https://prehuituaccess.sparta.html5.qq.com';

// 积分首页
export const userLevelInfoH5 = `${host}/mizar/integration/users/userLevelInfoH5`;
// 列表
export const userLevelRelatedDetailList = `${host}/mizar/integration/users/userLevelRelatedDetailList`;
// 用户使用等级回升的记录
export const userEquityRecord = `${host}/mizar/integration/users/equity/record`